export default {
    cambodia: 'ប្រទេសកម្ពុជា',
    thailand: 'ប្រទេសថៃ',
    in_region: 'នៅក្នុងតំបន់ {regionName}',
};
